import { render, staticRenderFns } from "./SUPACells.vue?vue&type=template&id=1060492d&scoped=true&"
import script from "./SUPACells.vue?vue&type=script&lang=ts&"
export * from "./SUPACells.vue?vue&type=script&lang=ts&"
import style0 from "./SUPACells.vue?vue&type=style&index=0&id=1060492d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1060492d",
  null
  
)

export default component.exports